import QRCodeStyling from 'qr-code-styling';
import { useEffect, useRef } from 'react';

const qr = new QRCodeStyling({
  width: 250,
  height: 250,
  type: 'svg',
  dotsOptions: {
    color: '#ff0000',
    type: 'rounded',
  },
  backgroundOptions: {
    color: 'transparent',
  },
  imageOptions: {
    crossOrigin: 'anonymous',
    margin: 10,
  },
});

type Props = {
  url: string;
};

export const QRCode = ({ url }: Props) => {
  const qrRef = useRef(null);

  console.log(url);

  useEffect(() => {
    if (qrRef.current) {
      qr.append(qrRef.current);
    }
  }, []);

  useEffect(() => {
    if (url) {
      qr.update({
        data: url,
      });
    }
  }, [url]);

  return (
    <div className="bg-[#ffffff] p-4 rounded">
      <div ref={qrRef} />
    </div>
  );
};
